import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

const SherwinWilliamsLogo = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 250.11 35.37'} {...props}>
    <svg
      id="Layer_2"
      data-name="Layer 2"
      fill={props?.fill ?? '#0067b1'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 345.11 35.37"
    >
      <defs>
        <style>
          {/* .cls-1 {
        fill: #0067b1;
      } */}
        </style>
      </defs>
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <g>
            <path
              className="cls-1"
              d="M346.18,24.91c2.34-.11,4.2,1.88,3.89,4.22-.22,1.64-1.54,2.96-3.18,3.18-2.44.32-4.52-1.75-4.19-4.19.23-1.74,1.71-3.13,3.48-3.21ZM346.26,25.66c-2.26.1-3.6,2.61-2.38,4.54s3.86,1.84,5.02,0c1.27-2.02-.27-4.65-2.64-4.54Z"
            />
            <path
              className="cls-1"
              d="M344.76,26.6h1.74c.58.04,1.16.19,1.26.85.07.45-.05.87-.46,1.11l-.27.11c.27.06.45.28.58.5l.66,1.32h-1.07l-.5-1.02c-.1-.21-.3-.45-.56-.45h-.38v1.47h-1v-3.89ZM345.76,28.32c.37-.02.96.11,1.01-.42.04-.42-.17-.58-.57-.59h-.44v1Z"
            />
          </g>
          <g>
            <path
              className="cls-1"
              d="M186.35.35c-.18,1.03.2,2.01.25,2.98.38,6.77.16,13.61.7,20.38.03.43-.07.77.37,1.06L197.98.35h7.56l.36,24.19.81-.87L216.81.35h5.76l-14.27,31.38h-7.08l-.24-25.01-.6-.14-10.43,25.15h-7.2l-1.92-31.38h5.52Z"
            />
            <polygon
              className="cls-1"
              points="96.65 6.58 97.49 25.02 105.52 6.58 112.72 6.58 112.72 24.78 121.71 6.58 127.11 6.58 115.12 31.73 108.4 31.73 108.04 12.56 99.53 31.73 92.81 31.73 91.13 6.58 96.65 6.58"
            />
            <polygon
              className="cls-1"
              points="294.52 31.73 299.32 6.58 307.5 6.72 309.16 23.82 318.39 6.58 326.42 6.58 321.39 31.73 316.11 31.73 320.18 12.57 310.24 31.49 305.46 31.74 303.28 12.32 299.32 31.73 294.52 31.73"
            />
            <polygon
              className="cls-1"
              points="134.3 31.73 139.58 6.58 146.53 6.59 151.69 24.78 155.65 6.58 160.93 6.58 155.39 31.7 148.48 31.7 143.3 13.28 139.22 31.73 134.3 31.73"
            />
            <path
              className="cls-1"
              d="M23.25,5.86c-2.63-.72-4.94-1.7-7.76-1.41-2.65.28-5.56,2.09-4.48,5.13,1.42,4.01,9.98,4.53,10.78,11.03,1.51,12.37-13.31,13.45-21.79,10.14l1.58-4.76c3.6,1.7,11.22,3.56,13.48-.9,3.06-6.03-5.17-7.48-8.23-10.38s-2.96-7.71-.48-10.78C10.29-.96,18.94-.59,24.36,1.3l-1.1,4.56Z"
            />
            <path
              className="cls-1"
              d="M66.91,31.73l5.63-25.17c4.52.48,15.12-1.92,15.93,4.71.55,4.47-1.78,7.46-6.21,8,.49.71,1.03.98,1.38,1.86,1.2,3.03,1.52,7.39,2.46,10.6h-5.4c-.16-.1-.25-.24-.31-.41-.76-2.11-.94-7.4-2-9.02-.8-1.22-2.63-.79-3.91-.88l-2.3,10.31h-5.28ZM75.54,17.12h3.48c.46,0,2.65-.99,3.01-1.37.21-.22.83-1.36.89-1.68.81-3.77-3.57-3.38-6.03-3.43l-1.35,6.48Z"
            />
            <polygon
              className="cls-1"
              points="33.33 6.58 31.41 16.64 41.24 16.64 43.4 6.58 48.68 6.58 43.4 31.73 38.13 31.73 40.28 20.71 30.57 20.71 28.05 31.73 22.78 31.73 28.05 6.58 33.33 6.58"
            />
            <path
              className="cls-1"
              d="M267.9,31.73l14.27-24.91,5.61-.2,4.35,25.12h-5.04l-.72-5.75c-2.92.26-6.4-.35-9.25-.02-.35.04-.63.02-.8.4l-2.66,5.36h-5.76ZM285.65,21.91l-1.56-10.3-5.16,10.3h6.72Z"
            />
            <path
              className="cls-1"
              d="M68.11,6.58l-.72,4.07-9.84.12-1.44,5.87h8.87l-.72,4.07-9,.23c-.23.23-1.45,5.7-1.46,6.22,0,.28.03.31.26.49h9.71l-1.08,4.07h-15.23l5.28-25.15h15.35Z"
            />
            <path
              className="cls-1"
              d="M342.25,11.61c-2.02-1.12-8.28-2.34-8.86.85s4.05,4.32,5.86,6.1c.89.87,1.9,2.71,2.04,3.95,1.15,10-9.7,11.3-16.79,8.26l1.56-4.54c2.8,1.86,9.35,3.18,10.05-1.49.65-4.34-7.41-4.48-8.01-9.89-.84-7.52,6.4-9.63,12.53-8.44.58.11,2.39.52,2.56,1.06l-.94,4.15Z"
            />
            <polygon
              className="cls-1"
              points="236.96 6.58 232.73 27.16 233 27.66 242 27.66 241.28 31.73 226.89 31.73 231.92 6.58 236.96 6.58"
            />
            <polygon
              className="cls-1"
              points="253.75 6.58 249.67 27.66 258.79 27.66 258.07 31.73 243.91 31.73 248.71 6.58 253.75 6.58"
            />
            <polygon className="cls-1" points="135.26 6.58 129.99 31.73 124.23 31.73 129.87 6.58 135.26 6.58" />
            <polygon className="cls-1" points="227.84 6.58 222.81 31.73 217.53 31.73 222.57 6.58 227.84 6.58" />
            <polygon className="cls-1" points="270.78 6.58 265.74 31.73 260.46 31.73 265.5 6.58 270.78 6.58" />
            <path className="cls-1" d="M175.8,16.88c-.48,1.72-.56,3.71-1.32,5.27h-10.43l.96-5.27h10.79Z" />
          </g>
        </g>
      </g>
    </svg>
  </SvgIcon>
)
export default SherwinWilliamsLogo
